import { IBaseFlyToOptions } from "hooks/map"
import { Coordinate } from "services/venue"

const REGEX_PATTERNS = {
  mapView:
    /^(-?\d+\.\d+),(-?\d+\.\d+),(\d+(\.\d+)?)+z,(-?\d+(\.\d+)?)?p,(-?\d+(\.\d+)?)?b(,(\d+)?ts)?$/,
}

type IsMapViewQueryString = (path: string | undefined) => boolean

type CreateMapViewConfigByPath = (
  path: string | null
) => IBaseFlyToOptions | null

export const isMapViewQueryString: IsMapViewQueryString = (path) =>
  REGEX_PATTERNS["mapView"].test(path)

export const convertMapViewObjectToPath = (
  mapView: IBaseFlyToOptions = {}
): string => {
  const {
    center,
    zoom = "",
    pitch = "",
    bearing = "",
    timestamp = new Date().getTime(),
  } = mapView || {}
  //@ts-ignore
  const parsedCeter = center?.toArray ? center.toArray() : center
  return `${parsedCeter},${zoom}z,${pitch}p,${bearing}b,${timestamp}ts`
}

export const createMapViewConfigByPath: CreateMapViewConfigByPath = (path) => {
  if (!path) return null

  try {
    const [, latitude, longtitude, z, , p, , b, , , ts = new Date().getTime()] =
      path.match(REGEX_PATTERNS["mapView"])
    const center = [parseFloat(latitude), parseFloat(longtitude)] as Coordinate
    const zoom = z ? parseFloat(z) : null
    const pitch = p ? parseFloat(p) : null
    const bearing = b ? parseFloat(b) : null
    const timestamp = +ts
    return {
      center,
      zoom,
      pitch,
      bearing,
      timestamp,
    }
  } catch (error) {
    return null
  }
}
